import z from "zod";

import { DineOutTimesOptions } from "@/api/admin/diners";

export const FormSchema = z.object({
  socialLinks: z.string().max(255).nullable().optional(),
  favoriteRestaurantType: z.string().max(255).nullable().optional(),
  favoriteRestaurantDescription: z.string().max(500).nullable().optional(),
  dineOutTimes: z
    .enum(DineOutTimesOptions.map(option => option.value))
    .nullable()
    .optional(),
  numberOfFollowers: z
    .union([z.number().min(0), z.string()])
    .nullable()
    .optional(),
  qualificationScore: z
    .union([z.number().min(0), z.string()])
    .nullable()
    .optional(),
  tierId: z.string().nullable().optional(),
  referralRuleIds: z.array(z.string()).nullable().optional(),
});

export type AdditionalFormType = z.infer<typeof FormSchema>;
